<template>
  <el-select v-model="value" @change="change"
             filterable
             clearable
             remote
             reserve-keyword
             :loading="loading"
             :remote-method="getDspSlotName"
             :multiple="multiple"
    size="medium" placeholder="请选择DSP广告位">
    <el-option v-for="item in slotNameOptions" :key="item.dspSlotId" :label="item.dspSlotName"
      :value="item.dspSlotId" />
  </el-select>
</template>

<script>
import { getDspSlotName, getDspSlotDimName } from '@/api/select'
import { hot } from '@/api/hot'

export default {
  props: {
    modelValue: [String, Number, Array],
    dspId: {
      type: [String, Number],
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: false
    },
    slotIsEnable: {
      type: Boolean,
      default: true
    },
    clearOnDspChange: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'change'],
  data () {
    return {
      slotNameOptions: [],
      value: this.multiple ? [] : undefined,
      loading: false,
      hasVal: undefined
    }
  },
  watch: {
    dspId () {
      if (this.clearOnDspChange) {
        if (this.multiple) {
          this.value = []
          this.change([])
        } else {
          this.value = ''
          this.change('')
        }
      }
      this.getDspSlotName()
    },
    modelValue: {
      handler (n) {
        this.value = n
        if (this.hasValue(n) && this.slotNameOptions.length === 0) {
          this.getDspSlotName()
        }
      },
      immediate: true
    }
  },
  mounted () {
    if (this.hasValue(this.modelValue)) {
      this.getDspSlotName()
    }
  },
  methods: {
    hasValue (val) {
      if (val === undefined || val === null || val === '') return false
      if (Array.isArray(val)) return val.length > 0
      return true
    },
    getDspSlotName (query) {
      this.loading = true
      getDspSlotName({ dspId: this.dspId, searchKey: query }).then(res => {
        if (res.code === 200) {
          this.slotNameOptions = res.data
          this.slotNameOptions.map((item) => {
            let s = ''
            if (item.isEnable === 0) {
              s = '(启用)'
            } else {
              s = '(禁用)'
            }
            item.dspSlotName = item.dspSlotName + '-' + item.dspSlotCode + '-' + s
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    change (item) {
      const data = {
        maker: 'slotDspOnThe',
        onTheOrderId: item
      }
      if (item && !this.multiple) {
        hot(data)
      }
      this.$emit('update:modelValue', item)
      this.$emit('change', item)
    },
    fun (val) {
      if (val) {
        val = val.replace(/^\s+|\s+$/gm, '')
        getDspSlotDimName({ name: val }).then(res => {
          this.slotNameOptions = res.data
          this.slotNameOptions.map((item) => {
            item.dspSlotName = item.dspSlotName + '-' + item.dspSlotCode
          })
        })
      } else {
        this.getDspSlotName()
      }
    }
  }
}
</script>

<style scoped>

</style>
